import type { FC } from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';

import { getTestIdByParts } from 'utils/getTestIdByParts';
import type { WithTestId } from 'types/app';

import { selectUser } from '@Modules/auth/selector';
import type { SellerType } from '@Modules/offers/types';

import { FavoriteButton } from '@Atomic/molecules/FavoriteButton';
import { SellerBadges } from '@Atomic/molecules/SellerBadges';

import { OfferOwner } from '../OfferOwner';

import styles from './style.module.scss';

type SellerDetailsProps = WithTestId<{
  seller: SellerType;
  className?: string;
}>;

export const SellerDetails: FC<SellerDetailsProps> = ({
  seller,
  className,
  testId = 'seller-details',
}) => {
  const user = useSelector(selectUser);

  const canSubscribe = seller?.uuid && user?.uuid !== seller.uuid;
  const isOwner = Boolean(seller?.uuid && user?.uuid && user.uuid === seller.uuid);

  return (
    <div className={cn(styles.sellerDetails, className)} data-testid={testId}>
      <div className={styles.summary}>
        <OfferOwner seller={seller} withLinks />

        <SellerBadges
          business={seller.business}
          agency={seller.agency}
          proSeller={seller.proSeller}
          verified={seller.verified}
          isOwner={isOwner}
        />
      </div>

      {canSubscribe && (
        <FavoriteButton
          uuid={seller.uuid}
          fullWidth
          testId={getTestIdByParts(testId, 'button-favorite')}
          defaultFavorite={seller?.favorited}
        />
      )}
    </div>
  );
};
